import React from "react";
import authRoutes from "../modules/auth/routes";
import { renderRoutes } from "react-router-config"

import menuRoutes from "../modules/menu/routes"
import SecurityLayout from "../layouts/SecurityLayout"
import { BrowserRouter } from "react-router-dom";
import ordersRoutes from "../modules/stats/routes";
import clientsRoutes from "../modules/clients/routes";

import generalSettingsRoutes from "../modules/settings/routes";

export const config = [
    authRoutes,
    {
        id: "common",
        path: "/",
        name: "Общие",
        hide: false,
        component: SecurityLayout,
        routes: [
           ...ordersRoutes,
            ...clientsRoutes,
            ...menuRoutes,
            ...generalSettingsRoutes,
            /*...branchesRoutes,*/
        ]
    }
];


function WebRouterConfig() {
    return (
        <BrowserRouter>
            {renderRoutes(config)}
        </BrowserRouter>
    );
}

export default WebRouterConfig;
